/**
 * StarRating - Display star ratings with optional review count
 * Supports half-stars and custom sizes
 */
import React from 'react';
import { FONT_FAMILY } from '../ShopStyles';

const StarRating = ({ 
  rating = 0, 
  reviewCount = null, 
  size = 'medium', 
  showCount = true,
  compact = false 
}) => {
  // Get star sizes
  const sizes = {
    small: { star: 14, text: 11, gap: 2 },
    medium: { star: 18, text: 13, gap: 4 },
    large: { star: 24, text: 16, gap: 6 },
  };
  const s = sizes[size] || sizes.medium;

  // Generate stars
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    const filled = rating >= i;
    const half = rating >= i - 0.5 && rating < i;
    
    stars.push(
      <span
        key={i}
        style={{
          fontSize: s.star,
          color: filled || half ? '#fbbf24' : '#d1d5db',
          position: 'relative',
          display: 'inline-block',
        }}
      >
        {half ? (
          <>
            <span style={{ position: 'absolute', left: 0, overflow: 'hidden', width: '50%', color: '#fbbf24' }}>★</span>
            <span style={{ color: '#d1d5db' }}>★</span>
          </>
        ) : (
          '★'
        )}
      </span>
    );
  }

  return (
    <div style={styles.container}>
      <div style={{ display: 'flex', gap: s.gap }}>{stars}</div>
      {showCount && reviewCount !== null && (
        <span style={{ 
          ...styles.reviewCount, 
          fontSize: s.text,
          marginLeft: s.gap + 2,
        }}>
          {compact ? (
            `(${reviewCount})`
          ) : (
            <>
              <span style={styles.ratingNum}>{rating.toFixed(1)}</span>
              <span style={styles.separator}>•</span>
              <span>{reviewCount.toLocaleString()} review{reviewCount !== 1 ? 's' : ''}</span>
            </>
          )}
        </span>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  reviewCount: {
    color: '#6b7280',
    fontFamily: FONT_FAMILY,
  },
  ratingNum: {
    fontWeight: '600',
    color: '#374151',
  },
  separator: {
    margin: '0 4px',
    opacity: 0.5,
  },
};

export default StarRating;
